import { createRouter, createWebHistory } from 'vue-router'
import ElTemplate from '../App.vue'

const routes = [
    {
        path: '/',
        component: ElTemplate,
        meta: { locale: 'el' },
    },
    {
        path: '/en',
        component: ElTemplate,
        meta: { locale: 'en' },
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/'
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 } // <-- πάντα τέρμα πάνω
    },
})

export default router;
